import { useState } from "react";
import { LoadingIcon } from "../../assets/icons";
import { reenrollMember } from "../../service/query/auth";
import { toast } from "react-toastify";

export default function ResetEnrolment() {
    const [membershipId, setMembershipId] = useState("");
    const [reenrolling, setReenrolling] = useState(false);
    const [reenrollResult, setReenrollResult] = useState(null);

    const handleReenroll = async () => {
        if (!membershipId) return;
        setReenrolling(true);
        setReenrollResult(null);
        try {
            const res = await reenrollMember({ membership_id: parseInt(membershipId) });
            const msg = res?.data?.message ?? "Member re-enrolled successfully";
            setReenrollResult({ success: true, message: msg });
            toast.success(msg);
        } catch (err) {
            console.log("Full error:", err?.response?.data);
            console.log("Full err object:", err?.response);
            const errData = err?.response?.data;
            const msg = errData?.message ?? "Re-enroll failed. Please try again.";
            setReenrollResult({ success: false, message: typeof msg === "string" ? msg : JSON.stringify(msg) });
            toast.error(typeof msg === "string" ? msg : "Re-enroll failed");
        } finally {
            setReenrolling(false);
        }
    };

    const isValid = membershipId.trim() !== "";

    return (
        <div className="bg-white pt-8 min-h-[80vh]">
            <div className="max-w-[600px]">

                {/* Membership ID input */}
                <div className="mb-[29px]">
                    <label className="block text-[12px] font-medium text-black mb-[10px]">
                        Membership ID <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        value={membershipId}
                        onChange={(e) => {
                            setMembershipId(e.target.value);
                            setReenrollResult(null);
                        }}
                        placeholder="Enter membership ID"
                        className="w-full px-[15px] py-[10px] border border-[#CED4DF] rounded-[5px] h-[45px] focus:outline-none focus:ring-1 focus:ring-blue-900 text-[14px]"
                    />
                </div>

                {/* Re-enroll section */}
                <div className="border border-[#E9EAEB] rounded-lg p-6">
                    <h4 className="text-[14px] font-semibold text-[#212121] mb-2">Re-enroll Member</h4>
                    <p className="text-[12px] text-[#64748B] mb-4">
                        Re-enroll a member using their email address. Use this when a member's account needs to be re-activated.
                    </p>
                    <button
                        onClick={handleReenroll}
                        disabled={!isValid || reenrolling}
                        className={`px-8 py-2 rounded-[5px] text-white text-[14px] flex items-center justify-center w-[180px] h-[38px] transition-all ${
                            !isValid || reenrolling
                                ? "bg-gray-300 cursor-not-allowed"
                                : "bg-[#00305E] hover:bg-blue-800"
                        }`}
                    >
                        {reenrolling ? <LoadingIcon /> : "Re-enroll"}
                    </button>

                    {reenrollResult && (
                        <p className={`mt-4 text-[13px] font-medium ${reenrollResult.success ? "text-[#0E9F6E]" : "text-[#E02424]"}`}>
                            {reenrollResult.message}
                        </p>
                    )}
                </div>

            </div>
        </div>
    );
}